import { makeStyles } from "@material-ui/styles";

const navigationTabPanelStyles = makeStyles(() => ({
	tabPanel: {
		height: "calc(100% - 57px)"
	},
	tabLink: {
		textDecoration: "none",
		color: "unset",
		display: "flex",
		alignItems: "center"
	}
}));

export default navigationTabPanelStyles;
